import { createFileRoute } from "@tanstack/react-router";
import { WebhooksPage } from "../components/webhooks/WebhooksPage";
import { ToWorkspaces } from "../components/workspaces/ToWorkspaces";
import { ApiError } from "../lib/api";
import { workspaceSlug } from "../lib/hosts";
import { useWorkspace } from "../lib/workspaces";

/** The workspace's webhooks (BUILD_SPEC §18.2), for whoever manages any: Administrators, and projects' admins. */
function WebhooksRoute() {
  const view = useWorkspace(workspaceSlug());
  if (view.isLoading) return null;
  if (view.error instanceof ApiError || !view.data) return <ToWorkspaces />;
  return <WebhooksPage administers={view.data.role === "administrator"} />;
}

export const Route = createFileRoute("/admin/settings/webhooks")({ component: WebhooksRoute });
